import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
import * as R from 'ramda'
import i18n from 'i18next'

import Select from '../../form/Select'
import Input from '../../form/Input'
import Modal from '../../../UniformComponents/Modal'
import Button from '../../../UniformComponents/Button'

@observer
class SurveyQuotaModal extends Component {
    @observable selections = observable.map({})

    targetPage = ''

    pageId = ''

    quota = 0

    componentWillMount() {
        this.initState()
    }

    initState = () => {
        const {
            store,
        } = this.props
        const { survey } = store

        const foundSkipLogic = R.pathOr([], ['skipLogic'], survey).find((sl) => sl.action.kind === 'OverallQuotaTopage')

        let defaultSkipLogic

        const defaultToPage = R.defaultTo({
            value: 'INVALID',
            label: 'INVALID',
        })

        this.page_options = survey.pages.reduce((arr, page, index) => {
            arr.push({
                value: page.id,
                label: `${i18n.t('s_page')}: ${(index + 1)}${(page.title ? (` - ${page.title}`) : '')}`,
            })
            return arr
        }, [{
            value: -1, label: i18n.t('form.general.please_select_ellipsis'),
        }])

        const sectionSkipLogic = R.defaultTo(defaultSkipLogic)(foundSkipLogic)
        this.triggerLens = R.lensPath(['trigger', 'condition'])
        this.actionLens = R.lensPath(['action'])
        const trigger = R.view(this.triggerLens)(sectionSkipLogic)
        const quota = R.pathOr(0, ['quota'], trigger)

        const targetPage = defaultToPage(this.page_options.find(({ value }) => (
            value === R.pathOr(-1, ['action', 'pageId'])(sectionSkipLogic)
        )))

        if (targetPage) {
            this.pageId = targetPage.value
        }

        this.quota = quota
        this.targetPage = targetPage
    }

    changeQuestionQuota = (e) => {
        const quota = parseInt(e.value, 10)
        this.quota = quota
    }

    setQuestionQuotaRouting = (obj) => {
        this.pageId = obj.value
    }

    save = () => {
        const { store, that } = this.props
        const { survey } = store

        let skipLogic

        const existingSkipLogic = survey.skipLogic.find((sl) => sl.action.kind === 'OverallQuotaTopage')

        if (existingSkipLogic) {
            existingSkipLogic.action.pageId = this.pageId
            existingSkipLogic.trigger.condition.quota = this.quota
            skipLogic = existingSkipLogic
        } else {
            skipLogic = survey.newQuotaFullToPage(this.pageId, this.quota)
        }

        try {
            skipLogic.save(store)
            that.hideSurveyQuotaModal()
        } catch (e) {
            console.error(e)
        }
    }

    render() {
        const { that } = this.props
        const { quota, targetPage } = this

        return (
            <Modal
                show={that.surveyQuotaModalOpen}
                onClose={that.hideSurveyQuotaModal}
            >
                <h2>{i18n.t('s_overall_quota_skiplogic_title')}</h2>

                <br />

                <br />

                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 20 }}>
                    <Input
                        type="number"
                        label={i18n.t('skipLogicModal.quotaResponsesLabel')}
                        cssClass="reponses-input"
                        min={0}
                        step={1}
                        defaultValue={quota}
                        onBlur={this.changeQuestionQuota}
                    />

                    <Select
                        clearable={false}
                        label={i18n.t('skipLogicModal.pageRoute')}
                        options={this.page_options}
                        defaultValue={R.pathOr(-1, ['value'], targetPage)}
                        onBlur={this.setQuestionQuotaRouting}
                        style={{ width: '100%' }}
                    />
                </div>

                <br />

                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                    <Button
                        label={i18n.t('skipLogicModal.saveLogic')}
                        icon="fal fa-save"
                        cssClass="regular primary"
                        onClick={this.save}
                    />
                </div>
            </Modal>
        )
    }
}

export default SurveyQuotaModal
